<template>
    <div>
        <div class="d-flex justify-content-end mb-4">
            <b-button class="btn-new" variant="primary" href="/v2/target/units-of-measurement/new">
                {{ $t('form.button.new') }}
            </b-button>
        </div>
        <b-card no-body>
            <b-card-header>
                <i class="icon-list"></i>
                <strong>{{ $t('unitsOfMeasurement.unitsOfMeasurement') }}</strong>
            </b-card-header>
            <b-card-body>
                <Loader :loader="loader" />
                <v-server-table
                    id="listOfUnitsOfMeasurement"
                    ref="listOfUnitsOfMeasurement"
                    class="data-table-default"
                    :columns="data.columns"
                    :options="data.options"
                    :theme="data.theme"
                    v-show="!loader"
                >
                    <template #update="{ row }">
                        <div class="td-action">
                            <b-link :href="`edit/${row.id}`" :title="$t('form.button.edit')">
                                <i class="fa fa-pencil fa-lg text-primary"></i>
                            </b-link>
                        </div>
                    </template>
                    <template #delete="{ row }">
                        <div class="td-action">
                            <b-link :title="$t('form.button.delete')" @click="deleteUnitsOfMeasurement(row.id)">
                                <i class="fa fa-trash fa-lg text-danger"></i>
                            </b-link>
                        </div>
                    </template>
                </v-server-table>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import Vue from 'vue'
import Swal from 'sweetalert2'
import { ServerTable } from 'vue-tables-2'
import i18n from '@/i18n'
import api from '@/services/api'
import configDataTable from '@/config/data-table'
import { deleteConfirmationWithLoading } from '@/config/sweet-alert'
import notification, { success, danger } from '@/lib/notification'
import Loader from '@/views/components/loader'
import { userPermissionsMixin } from '@/mixins'

notification.init()
Vue.use(ServerTable)

export default {
    name: 'List',
    components: {
        ServerTable,
        Loader,
    },
    mixins: [userPermissionsMixin],
    data() {
        const _self = this
        const { options, theme } = configDataTable
        return {
            loader: true,
            data: {
                columns: ['title', 'update', 'delete'],
                options: {
                    sortable: ['title'],
                    filterable: ['title'],
                    orderBy: { column: 'title' },
                    headings: {
                        title: i18n.t('form.label.title'),
                        update: i18n.t('form.button.edit'),
                        delete: i18n.t('form.button.delete'),
                    },
                    requestFunction(data) {
                        _self.loader = true
                        const { limit, page, query, byColumn, orderBy, ascending } = data
                        return api
                            .get('/units-of-measurement', {
                                params: {
                                    limit,
                                    page,
                                    query,
                                    byColumn,
                                    orderBy,
                                    ascending,
                                },
                            })
                            .catch((e) => {
                                console.log(e)
                            })
                    },
                    responseAdapter(response) {
                        _self.loader = false
                        const { data, count } = response.data.data
                        return {
                            data,
                            count,
                        }
                    },
                    ...options,
                },
                ...theme,
            },
        }
    },
    mounted() {
        if (
            !this.currentUserHasRolePermissionsOf(['god', 'administrator', 'local_administrator', 'is_target_master'])
        ) {
            this.$router.push({
                path: '/v2/pages/error/403',
            })
        }
    },
    methods: {
        deleteUnitsOfMeasurementFromAPI(id) {
            return api
                .delete(`/units-of-measurement/${id}`)
                .then(() => {
                    this.$refs.listOfUnitsOfMeasurement.refresh()
                })
                .catch((e) => {
                    throw new e()
                })
        },
        deleteUnitsOfMeasurement(id) {
            Swal({
                ...deleteConfirmationWithLoading,
                preConfirm: () => {
                    return this.deleteUnitsOfMeasurementFromAPI(id)
                },
            })
                .then((resp) => {
                    const { value } = resp
                    if (value) {
                        this.notificationUnitsOfMeasurementDeletedSuccessfully()
                    }
                })
                .catch(() => {
                    Swal({
                        type: 'warning',
                        title: i18n.t('unitsOfMeasurement.userCannotDeleteAnUnitOfMeasurement'),
                        cancelButtonText: i18n.t(`modal.close`),
                        showCancelButton: true,
                        showConfirmButton: false,
                    })

                    this.$router.go(-1)
                })
        },
        notificationUnitsOfMeasurementDeletedSuccessfully() {
            success(
                i18n.t('notification.deletedSuccessfully', {
                    item: i18n.t('unitsOfMeasurement.unitOfMeasurement'),
                })
            )
        },
        notificationError() {
            danger()
        },
    },
}
</script>

<style lang="scss" scope>
@import '@/scss/VueTableDefault.scss';

#listOfUnitsOfMeasurement {
    .VueTables__table {
        .td-action {
            text-align: center;
        }
        th:nth-child(2),
        th:nth-child(3) {
            width: 100px;
        }
    }
}
.btn-new {
    min-width: 80px;
}
</style>
